import toastr from 'toastr'

export default {
    success(message) {
        toastr.success(message, null, {timeOut: 2500, positionClass: 'toast-bottom-right'})
    },

    warning(message) {
        toastr.warning(message, null, {timeOut: 2500, positionClass: 'toast-bottom-right'})
    },

    error(message) {
        toastr.error(message, null, {timeOut: 2500, positionClass: 'toast-bottom-right'})
    }
}
